<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h3>Checkout</h3>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Description</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in cart.items" v-bind:key="item.id">
          <td>{{item.description}}</td>
          <td>${{item.amount}}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${{totalPrice}}</td>
        </tr>
      </tbody>
    </table>
    <div class="row" v-if="totalPrice > 0">
      <div class="col">
        <button class="btn btn-primary btn-lg text-center" @click="payByCreditCard">Pay with Credit Card</button>
      </div>
      <div class="col">
        <div class="alert alert-primary">
          If your financial institution requires a Company ID, the NEW Company/Provider ID is 0000408976.
          <i>(The current COMPANY ID may still be used until the change takes place)</i>
        </div>
        <button class="btn btn-primary btn-lg" @click="payByAch">Pay with ACH</button>
      </div>
    </div>
    <div v-else>
      <p>
        Finalize and submit the transaction:
      </p>
      <button class="btn btn-primary" @click="finalize">
        Submit Transaction
      </button>
    </div>
    <form ref="lexisNexisForm" method="post" :action="lnLexisNexisPostUrl">
      <input type="hidden" name="ORDER_XML" v-model="orderXml" />
    </form>
  </div>
</template>
<script>
import { getPermitCart, errorNotification, finalizeCart } from '~/js/FormFunctions'
import {ShoppingCart} from '~/js/FormObjects'

const sumReducer = (accumulator, currentValue) => accumulator + currentValue

export default {
  name: 'Checkout',
  data () {
    return {
      cart: new ShoppingCart(),
      fetchingData: false,
      permitId: null,
      revisionId: null,
      contractorRegId: null,
      orderXml: null,
      sessionId: null,
      lnReturnUrl: `${window.location.protocol}//${window.location.hostname}`
        + `${window.location.port ? `:${window.location.port}` : ''}/DesWebPortal/api/checkout/lnConfirm/`,
      // lnReturnUrl: 'http://localhost:8081/#/thankYou/'
      lnLexisNexisPostUrl: null
    }
  },
  mounted () {
    const self = this
  },
  methods: {
    payByCreditCard: function () {
   },
    payByAch: function () {
    },
    finalize: function () {
    }
  },
  computed: {
    totalPrice: function () {
      if (this.cart.items.length === 0) {
        return 0
      }
      return this.cart.items
        .map(i => i.amount)
        .reduce(sumReducer)
    }
  }
}</script>